<div class="py-20 bg-light">
  <div class="container mx-auto px-6 max-w-lg">
    <div class="bg-white dark:bg-slate-800 p-8 rounded-xl shadow-lg dark:shadow-slate-900/50 border">
      <h2 class="text-3xl font-bold text-secondary text-center mb-2">
        Finaliser votre abonnement
      </h2>

      <!-- Si plan est défini -->
      @if (plan; as selectedPlan) {
        <p class="text-center text-gray-600 dark:text-gray-400 mb-8">
          Vous avez choisi le plan
          <span class="font-bold text-primary">{{ selectedPlan.name }}</span>.
        </p>
        <div class="bg-light p-6 rounded-lg mb-8 border">
          <div class="flex justify-between items-center text-lg">
            <span class="font-semibold text-secondary">
              Plan {{ selectedPlan.name }}
            </span>
            <span class="font-bold text-secondary">
              {{ selectedPlan.price }}
              <span class="text-sm font-normal text-gray-500 dark:text-gray-400">
                {{ selectedPlan.period }}
              </span>
            </span>
          </div>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Facturation mensuelle, annulable à tout moment.
          </p>
        </div>
        <!-- Erreur -->
        @if (errorMessage) {
          <div class="bg-red-100 dark:bg-red-900/30 border-l-4 border-red-500 text-red-700 dark:text-red-300 p-4 mb-6" role="alert">
            <p>{{ errorMessage }}</p>
          </div>
        }
        <!-- Bouton -->
        <button
          type="button"
          (click)="proceedToPayment()"
          [disabled]="isLoading"
          class="w-full bg-primary text-white font-semibold text-lg py-3 rounded-lg
                 hover:bg-primary-hover transition-colors shadow-md dark:shadow-slate-900/50
                 disabled:bg-primary/50 disabled:cursor-not-allowed
                 flex items-center justify-center"
          >
          @if (isLoading) {
            <svg
              class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373
                   0 12h4zm2 5.291A7.962 7.962 0 014
                   12H0c0 3.042 1.135 5.824 3
                   7.938l3-2.647z"
              ></path>
            </svg>
            <span>Traitement...</span>
          } @else {
            <span>Procéder au paiement</span>
          }
        </button>
        <p class="text-center text-xs text-gray-500 dark:text-gray-400 mt-4">
          Vous allez être redirigé vers notre portail de paiement sécurisé Stripe.
        </p>
      } @else {
        <p class="text-center text-gray-600 dark:text-gray-400">Chargement des informations du plan...</p>
      }

      <!-- Sinon chargement -->

    </div>
  </div>
</div>
